import { render, staticRenderFns } from "./Damaged_details.vue?vue&type=template&id=6680aa92&scoped=true&"
import script from "./Damaged_details.vue?vue&type=script&lang=js&"
export * from "./Damaged_details.vue?vue&type=script&lang=js&"
import style0 from "./Damaged_details.vue?vue&type=style&index=0&id=6680aa92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6680aa92",
  null
  
)

export default component.exports